import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { IconTerminal2 } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

import { ThemeMode } from 'config';
import useLocalization from 'hooks/useLocalization';
import { useSelector } from 'store';
import { isOpsConsoleCompany } from 'utils/route-guard/OpsConsoleGuard';

/**
 * קיצור דרך ל-ops console — מוצג רק לחברת פאנר הפנימית (אותה בדיקה כמו OpsConsoleGuard).
 * ההסתרה כאן היא UX בלבד; ההרשאות נאכפות ב-Guard של הנתיב וב-opsGuard בצד השרת.
 */
export default function OpsConsoleHeaderLink() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { currentLocale } = useLocalization();
  const userCompanyId = useSelector((state) => state.user?.CompanyId);
  const companyId = useSelector((state) => state.company?.CompanyId);

  const isAllowed = [userCompanyId, companyId, localStorage.getItem('companyId')].some(
    isOpsConsoleCompany,
  );

  if (!isAllowed) return null;

  return (
    <Tooltip title={currentLocale.opsConsole.title}>
      <Avatar
        variant="rounded"
        sx={{
          ...theme.typography.commonAvatar,
          ...theme.typography.mediumAvatar,
          transition: 'all .2s ease-in-out',
          bgcolor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'secondary.light',
          color: theme.palette.mode === ThemeMode.DARK ? 'warning.dark' : 'secondary.dark',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: theme.palette.mode === ThemeMode.DARK ? 'warning.dark' : 'secondary.dark',
            color: theme.palette.mode === ThemeMode.DARK ? 'grey.800' : 'secondary.light',
          },
        }}
        onClick={() => navigate('/ops-console')}
        aria-label={currentLocale.opsConsole.title}
        color="inherit"
      >
        <IconTerminal2 stroke={1.5} size="20px" />
      </Avatar>
    </Tooltip>
  );
}
